import { jsx as _jsx } from "react/jsx-runtime";
import { LegacyDevice } from 'console/device/device';
import { DevicePermission } from 'console/device/device_ts';
import { DefaultTabKey } from 'console/shared/content/tab/types';
import { TerminalSharp } from '@mui/icons-material';
import { TerminalCard } from 'console/shared/components/panels/terminal';
export const terminal_tab_definition = {
    key: DefaultTabKey.terminal,
    title: 'Терминал',
    iconclass: '',
    icon: (_jsx(TerminalSharp, { style: {
            display: 'inline-block',
            width: '26px',
            height: '26px',
        } })),
    should_appear: (_, _1, r_device, r_account) => {
        if (!r_device) {
            return false;
        }
        if (!LegacyDevice.has_access(r_account.id, r_device, DevicePermission.ext_configure)) {
            return false;
        }
        return !!r_account.allow_terminal;
    },
    render: TerminalCard,
    should_appear_depends_on: [
        'user_id',
        'access',
        'timezone',
        'capabilities',
        'debug_text_messages_regexp',
    ],
};
